import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { AppState } from '../../../../../../store';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import Reviews from '../../../../../../common/Reviews';
import { detailsProduct } from '../../../../../../store/actions/productActions';
import Divider from '@mui/material/Divider';
import Price from '../../../../../../common/Price';
import CustomRating from '../../../../../../common/Rating';
import { useCommonStyles } from '../../../../../../common/common';
import Bazzskelton from '../../../../../../common/BazzSkelton';
import { addProductToCart } from '../../../../../../store/actions/cartActions';

export const Item = styled(Paper)(({ theme }) => ({
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: 'center',
	color: theme.palette.text.secondary,
}));

export default function ProductDetails(props: any) {
	const dispatch = useDispatch()
	const history = useHistory()
	const {selectedProduct} = useSelector<AppState, AppState['products']>(
        ({products}) => products,
    );
	const { loading } = useSelector<AppState, AppState['common']>(
		({ common }) => common,
	);
	const commonClasses = useCommonStyles()

	useEffect(() => {
		dispatch(detailsProduct(props.match.params.productId))
	}, [dispatch, props])

	const getReviewInfo = (selectedProduct: any, readOnly: boolean) => {
		return <Reviews
			readOnly={readOnly} 
			numReviews={selectedProduct.numReviews}
			defaultValue={selectedProduct.rating} 
		/>
	}

	const getSubTitleContent = (item: any) => {
		return <Box display="flex" flexDirection="column">
			<Box component="h6" display="inline-flex">
				<CustomRating rating={item.rating} />
			</Box>
			<Box display="flex" component="h6" justifyContent="space-between">
			  <Price price={item.price} />
			  <span>{item.seller.seller.name}</span>
			</Box>
		</Box>
	}

	const getformattedDate = (date: string) => {
		const d = new Date(date)
		const formattedDate = `${d.getDate()}-${d.getMonth()}-${d.getFullYear()}` 
		return formattedDate;
	}

	const handleAddToCard = (id: string) => {
		dispatch(addProductToCart(id, 1))
		history.push('/cartItems')
	}

	return (
		<Box className={commonClasses.mainContainer}>
			{/* Loading */}
			{loading && <Bazzskelton list={[1,2,3]} />}
			{/* No product found! */}
			{!loading && selectedProduct && Object.keys(selectedProduct).length === 0 && "No Results Found!"}
			{/* Products list */}
			{selectedProduct && 
			<Box style={{padding: '16px'}}>
				<Box sx={{ flexGrow: 1 }}>
					<Grid container spacing={0}>
						<Grid item xs={12} sm={4}>
							<Item className={commonClasses.itemCls} style={{margin: '8px', marginTop:'0x'}}>
								<ImageListItem key={selectedProduct._id} 
									style={{padding: '8px'}}
									>
									<img
										style={{height: '280px'}}
										src={`${selectedProduct.image}`}
										srcSet={`${selectedProduct.image}`}
										alt={selectedProduct.name}
										loading="lazy"
									/>
									<ImageListItemBar
										title={<b>{selectedProduct.name}</b>}
										subtitle={getSubTitleContent(selectedProduct)}
										position="below"
									/>
								</ImageListItem>
							</Item>
						</Grid>
						<Grid item xs={12} sm={4}>
							<Item style={{textAlign: 'left', padding: '18px', boxShadow: 'none'}}>
								<Box display="flex" flexDirection="column">
									<Box component="h5"><b>{selectedProduct.name}</b></Box>
									{getReviewInfo(selectedProduct, true)}
									<Box component="h6"><b>Price:</b> <Price price={selectedProduct.price} /></Box>
									<Box component="h6"><b>Description:</b> {selectedProduct.description}</Box>
									<Box component="h6"><b>Brand:</b> {selectedProduct.brand}</Box>
									<Box component="h6"><b>Category:</b> {selectedProduct.category}</Box>
									<Box component="h6"><b>Counts in stock:</b> {selectedProduct.countInStock}</Box>
								</Box>
								<Divider style={{margin: '12px'}} />
								<Box display="flex" flexDirection="column">
									<Box component="h5"><b>Reviews:</b></Box>
									{selectedProduct && selectedProduct.reviews.length === 0 && <p>No reviews</p>}
									{selectedProduct && selectedProduct.reviews.length > 0 &&
										selectedProduct.reviews.map((review: any) => {
											return <>
												<p style={{marginBottom: '4px'}}><b>Commented By:</b></p>
												<p style={{marginBottom: '4px'}}>{review.name}</p>
												<p style={{marginBottom: '4px'}}>{getReviewInfo(review, true)}</p>
												<p style={{marginBottom: '4px'}}>{getformattedDate(review.createdAt)}</p>
												<p><b>comment:</b> {review.comment}</p>
											</>
										})
									}
								</Box>
							</Item>
						</Grid>
						<Grid item xs={12} sm={4}>
							<Item  style={{textAlign: 'left', padding: '18px', boxShadow: 'none'}}>
								<Box display="flex" flexDirection="column">
									<Box component="h5"><b>Seller</b></Box>
									<Divider style={{marginBottom: '12px'}} />
									<Box component="h5">{selectedProduct.seller.seller.name}</Box>
									{getReviewInfo(selectedProduct.seller.seller, true)}
									<Box display="flex" component="h6" justifyContent="space-between">
										<b>Status</b>
										<span>{selectedProduct.countInStock > 0 ? 'In Stock': 'Out of Stock'}</span>
									</Box>
									<Box display="flex" component="h6" justifyContent="space-between">
										<b>Price</b>
										<Price price={selectedProduct.price} />
									</Box>
									<Box
										mt={{xs: 3, xl: 4}}
										display='flex'
										sx={{ flexDirection: { xs: 'column', md: 'row' }}}
										justifyContent="space-evenly"
									>
										<Button
											color="primary"
											variant="outlined"
											onClick={() => handleAddToCard(selectedProduct._id)}
											sx={{ color: '#fff', background: 'rgba(8, 1, 41, 1)', mb: { xs: 1, md: 0}}}
										>
											Add to Cart
										</Button>
										<Button
											color="secondary"
											variant="outlined"
											style={{ color: '#fff', background: 'linear-gradient(180deg, #C12902 67.71%, #E76240 100%)'}}
										>
											Buy Now
										</Button>
									</Box>
								</Box>
							</Item>
						</Grid>
					</Grid>
				</Box>
			</Box>}
		</Box>
	);
}
